// 레거시 appr_edit_forms_fnco_pre_marketing_ai <style> 원문 — 저장 content 에 그대로 실려 레거시 조회 화면이 이것으로 그림
export const FNCO_PRE_MARKETING_LEGACY_CSS = `
.apv_fnco_pre_mkt_case .container {
    padding: 0 0 20px 0;
    overflow: hidden;
    max-width: 100%;
}

.apv_fnco_pre_mkt_case .header {
    color: var(--dk-text, #000);
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.4;
}

.apv_fnco_pre_mkt_case .summary-section {
    padding: 16px;
    max-width: 100%;
    border-radius: 8px;
    border: 1px solid rgb(175, 178, 244);
    background: var(--dk-bg-subtle, rgb(249, 250, 251));
}

.apv_fnco_pre_mkt_case .summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.apv_fnco_pre_mkt_case .summary-title {
    display: flex;
    padding: 4px 12px;
    -webkit-box-align: center;
    align-items: center;
    gap: 2px;
    border-radius: 999px;
    background: linear-gradient(0deg, rgba(199, 122, 196, 0.12) 0%, rgba(199, 122, 196, 0.12) 100%), var(--dk-bg, rgb(255, 255, 255));
    color: rgb(199, 122, 196);
    font-size: 14px;
    line-height: 20px;
}

.apv_fnco_pre_mkt_case .detail-button {
    -webkit-box-pack: center;
    justify-content: center;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    user-select: none;
    vertical-align: middle;
    appearance: none;
    text-transform: none;
    font-size: 0.875rem;
    line-height: 1.75;
    color: rgb(199, 122, 196);
    box-shadow: none;
    font-weight: 400;
    min-width: auto;
    position: relative;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    outline: 0px;
    border-width: 0px;
    margin: 0px;
    text-decoration: none;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
    padding: 2px;
    border-radius: 8px;
    background: radial-gradient(400.9% 68.99%, rgb(175, 178, 244) 0%, rgb(225, 179, 223) 100%);
}
.apv_fnco_pre_mkt_case .detail-button .btn-content {
    padding: 6px 8px;
    display: flex;
    align-items: center;
    border-radius: 6px;
    background: var(--dk-bg, #fff);
}

.apv_fnco_pre_mkt_case  .detail-button span {
    border-radius: 6px;
    color: rgb(199, 122, 196);
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    display: inline-flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
}

.apv_fnco_pre_mkt_case .detail-button:hover {
    cursor: pointer;
    background-color: var(--dk-bg-subtle, #f5f5f5);
}

.apv_fnco_pre_mkt_case .summary-list {
    list-style: none;
    padding-inline-start: 10px;
    color: var(--dk-text, rgb(0, 0, 0));
    font-size: 16px;
    line-height: 1.6;
}

.apv_fnco_pre_mkt_case .summary-list li {
    margin-bottom: 8px;
    padding-left: 16px;
    position: relative;
}

.apv_fnco_pre_mkt_case .summary-list li::before {
    content: "•";
    position: absolute;
    left: 0;
    color: var(--dk-text-strong, #666);
}

.apv_fnco_pre_mkt_case .detail-section {
    border-radius: 8px;
    border: 1px solid var(--dk-bg, #FFF);
    background: var(--dk-bg, #FFF);
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 4px 0px inset, rgba(0, 0, 0, 0.08) 0px 0px 8px 0px;
    padding: 24px;
}

       .apv_fnco_pre_mkt_case  .project-title {
    line-height: 1.4;
    font-size: 20px;
    font-weight: 600;
}

.apv_fnco_pre_mkt_case .divider {
    border: none;
    border-top: 3px solid #000;
    margin: 24px 0;
}

.apv_fnco_pre_mkt_case .section-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 16px;
}

.apv_fnco_pre_mkt_case .info-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
    margin: 0 0 16px 0;
}

.apv_fnco_pre_mkt_case .info-item {
    display: flex;
    flex-direction: row;

    border-bottom: 1px solid var(--dk-line, rgb(231, 233, 236));
    padding: 8px 0;
}

.apv_fnco_pre_mkt_case .info-item:last-child {
    border-bottom: none;
}

.apv_fnco_pre_mkt_case .info-label {
    min-width: 136px;
    font-size: 14px;
    color: var(--dk-text-strong, #5F636B);
}

.apv_fnco_pre_mkt_case .info-value {
    font-size: 16px;
    color: var(--dk-text-primary, #333);
}

.apv_fnco_pre_mkt_case .info-value.content {
    white-space: pre-line;
    line-height: 1.5;
}

.apv_fnco_pre_mkt_case .brand-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.apv_fnco_pre_mkt_case .brand-logo {
    width: 24px;
    height: 24px;
    background: black;
    border-radius: 4px;
}

.apv_fnco_pre_mkt_case .budget-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.apv_fnco_pre_mkt_case .section-title {
    margin-bottom: 0;
}

.apv_fnco_pre_mkt_case .total-amount {
    font-size: 20px;
    font-weight: 500;
}

.total-amount .amount {
    color: var(--dk-accent, #0066cc);
    margin-left: 4px;
}

@media screen and (max-width: 990px) {
    .apv_fnco_pre_mkt_case .info-item {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .apv_fnco_pre_mkt_case .budget-summary {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

}

.table-container {
    position: relative;
    overflow-x: auto;
}

.budget-table {
    min-width: 100%;
    width: max-content;
    border-collapse: collapse;
    margin-bottom: 16px;
    font-size: 16px;
}

.budget-table td {
    padding: 8px;
    text-align: left;
    background-color: var(--dk-bg-subtle, #f8f9fa);
    border-bottom: 1px solid var(--dk-line, #e9ecef);
    border-left: 1px solid var(--dk-line, #e9ecef);
}

.budget-table td:first-child {
    border-left: none;
}

.budget-table tr:last-child td {
    border-bottom: 1px solid #000;
}

.budget-table td:nth-of-type(1) {
    min-width: 38px;
    width: 38px;
    max-width: 45px;
    text-align: center;
}
.budget-table td:nth-of-type(2) {
    min-width: 220px;
    width: 220px;
    max-width: 220px;
}
.budget-table td:nth-of-type(3) {
    min-width: 150px;
}
.budget-table td:nth-of-type(4) {
    min-width: 240px;
}
.budget-table td:nth-of-type(5) {
    min-width: 160px;
    width: 160px;
    max-width: 165px;
    text-align: right;
}

.budget-table .category-header,
.budget-table .category-header td {
    font-weight: 500;
}

.budget-table .category-header td {
    border: 0;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    background-color: var(--dk-bg, #FFF) !important;
}

.budget-table .category-header td:last-child {
    border-left: 1px solid var(--dk-line, #e9ecef);
}

.budget-table .amount-cell {
    text-align: right;
}

.progress-bar-container {
    width: 100%;
    height: 32px;
    position: relative;
    border-radius: 2px;
    overflow: hidden;
    margin-top: 16px;
}

.progress-fill {
    height: 100%;
    background-size: 37px 37px;
    pointer-events: none;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
}

.progress-fill.base {
    display: flex;
    width: 100%;
    border: 1px solid var(--dk-line, rgb(231, 233, 236));
    border-radius: 2px;
    background-image: repeating-linear-gradient(50deg, var(--dk-bg, rgb(255, 255, 255)) 0px, var(--dk-bg, rgb(255, 255, 255)) 4px, var(--dk-bg-muted, rgb(243, 245, 246)) 4px, var(--dk-bg-muted, rgb(243, 245, 246)) 7px);
}

.progress-fill.dark {
    background-image: repeating-linear-gradient(50deg, rgb(37, 124, 211) 0px, rgb(37, 124, 211) 4px, rgb(13, 110, 206) 4px, rgb(13, 110, 206) 7px);
}

.progress-fill.light {
    background-image: repeating-linear-gradient(50deg, rgb(175, 207, 239) 0px, rgb(175, 207, 239) 4px, rgb(150, 190, 230) 4px, rgb(150, 190, 230) 7px);
}

.budget-status-wrap {
    margin-top: 24px;
}

.budget-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid var(--dk-line, #e9ecef);
    font-size: 16px;
}

.budget-status-total {
    margin: 20px 0 10px 0;
    font-size: 18px;
}

.budget-status-total strong {
    display: block;
    padding: 10px 0;
    font-weight: 500;
    border-bottom: 1px solid #000;
}

.budget-status-total .budget-status:last-child {
    border-bottom: none;
}

.status-info {
    display: flex;
    align-items: center;
    gap: 8px;
    width: auto;
}

.status-dot {
    width: 26px;
    height: 26px;
    border-radius: 4px;
}

.status-used {
    border: 1px solid var(--dk-accent, rgb(0, 102, 204));
    background: rgba(0, 102, 204, 0.8);
    opacity: 1;
}
.status-current {
    border: 1px solid var(--dk-accent, rgb(0, 102, 204));
    background: rgba(0, 102, 204, 0.64);
    opacity: 0.4;
}
.status-remaining {
    border: 1px solid var(--dk-line-strong, rgb(183, 187, 194));
    background: var(--dk-bg-strong, rgb(231, 233, 236));
    opacity: 0.4;
}

@media screen and (max-width: 640px) {
    .budget-status {
        gap: 8px;
        flex-direction: column;
        font-size: 16px;
    }
    .budget-status > div {
        width: 100%;
        text-align: right;
    }
}

.sortable-table {
    min-width: 100%;
    border-collapse: collapse;
}

.budget-table tr > *,
.sortable-table tr > * {
    font-size: 14px !important;
}

.sortable-table th,
.sortable-table td {
    padding: 8px;
    vertical-align: middle;
    font-weight: 400;
    background-color: var(--dk-bg, rgb(255, 255, 255));
    border-bottom: 1px solid rgb(224, 224, 224);
}

.sortable-table th {
    position: relative;
    color: var(--dk-text, rgb(0, 0, 0));
    background-color: var(--dk-bg-subtle, rgb(249, 250, 251));
    border-top: 1px solid #000;
}

.sortable-table td:not(:last-child),
.sortable-table th:not(:last-child) {
    border-right: 1px solid var(--dk-line, rgb(240, 240, 240));
}

.sortable-table td:nth-of-type(1) {
    min-width: 220px;
    width: 220px;
    max-width: 220px;
}
.sortable-table td:nth-of-type(2) {
    min-width: 160px;
    width: 160px;
    max-width: 160px;
}
.sortable-table td:nth-of-type(3) {
    min-width: 160px;
    width: 160px;
    max-width: 160px;
}
.sortable-table td:nth-of-type(4) {
    min-width: 160px;
    width: 160px;
    max-width: 160px;
}
.sortable-table td:nth-of-type(5) {
    min-width: 160px;
    width: 160px;
    max-width: 160px;
}

.execution-rate {
    display: flex;
    justify-content: space-between;
    height: 16px;
    border-radius: 2px;
    overflow: hidden;
}

.rate-bar {
    width: calc(100% - 50px);
    height: 16px;
    border: 1px solid var(--dk-line, rgb(231, 233, 236));
    background-image: repeating-linear-gradient(50deg, var(--dk-bg, rgb(255, 255, 255)) 0px, var(--dk-bg, rgb(255, 255, 255)) 4px, var(--dk-bg-muted, rgb(243, 245, 246)) 4px, var(--dk-bg-muted, rgb(243, 245, 246)) 7px);
    background-size: 37px 37px;
    pointer-events: none;
}

.rate-fill {
    height: 100%;
    background-image: repeating-linear-gradient(50deg, rgb(37, 124, 211) 0px, rgb(37, 124, 211) 4px, rgb(13, 110, 206) 4px, rgb(13, 110, 206) 7px);
    background-size: 37px 37px;
    pointer-events: none;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
}

.rate-text {
    font-size: 14px;
    width: 56px;
    text-align: right;
}

.collapse-button {
    transform: scaleY(-1);
    transform-origin: center center;
    -webkit-box-pack: center;
    justify-content: center;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    user-select: none;
    vertical-align: middle;
    appearance: none;
    text-transform: none;
    font-size: 0.875rem;
    line-height: 1.75;
    color: var(--dk-text, rgb(0, 0, 0));
    box-shadow: none;
    font-weight: 400;
    min-width: auto;
    position: relative;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    outline: 0px;
    border-width: 0px;
    margin: 0px;
    text-decoration: none;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
    padding: 2px;
    background: none;
}
.collapse-button.open {
    transform: scaleY(1);
}

/* 요약 html */
.ai-cost-summary {
    color: var(--dk-text, #000);
    font-size: 18px;
    line-height: 26px;
    white-space: pre-line;
}

.ai-cost-summary__head {
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    margin-top: 16px;
}

.ai-cost-summary__subtitle {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    margin-top: 4px;
}

.ai-cost-summary__section-title {
    display: flex;
    align-items: center;
    margin-top: 12px;
}

/* 새로운 ul/li 스타일 */
.ai-cost-summary ul {
    padding-inline-start: 20px;
    color: var(--dk-text, #000);
    font-size: 18px;
    line-height: 26px;
    margin: 0;
}
.ai-cost-summary ul li {
    margin-top: 4px;
}
.ai-cost-summary ul li::marker {
    font-size: 12px;
}
`;
